import type { CSSProperties, ReactNode } from 'react';

import { Z_INDEX } from '@/config/z-index';

export type PageLayoutProps = {
  actions?: ReactNode;
  children?: ReactNode;
  stickyHeader?: boolean;
  tabs?: ReactNode;
  title: ReactNode;
};

export const PageLayout = ({
  actions,
  children,
  stickyHeader = false,
  tabs,
  title
}: PageLayoutProps) => {
  const stickyStyle: CSSProperties | undefined = stickyHeader
    ? {
        position: 'sticky',
        top: '-24px',
        zIndex: Z_INDEX.floatingAnchor
      }
    : undefined;

  return (
    <div>
      <header
        className='flex min-w-0 items-center gap-2 py-6'
        style={stickyStyle}
      >
        {title}
        {tabs ? <div className='min-w-0 flex-1'>{tabs}</div> : null}
        {actions ? <div className='ml-auto shrink-0'>{actions}</div> : null}
      </header>
      <main className='flex grow flex-col gap-6'>{children}</main>
    </div>
  );
};
